<template>
  <header>
    <vue-loading :active.sync="is_loading" :can-cancel="false" :is-full-page="false"></vue-loading>
    <div id="registration-details">
      <router-link class="nav-link" to="/register" tag="button" v-bind:class="'mt-2 mt-sm-0 btn btn-sm btn-dark btn-block'">Create a profile?
        <span class="text-primary"> Register</span></router-link>
    </div>
    <div id="covid-banner">
      <a class="mt-2 mt-sm-0  btn btn-sm btn-white btn-block" href="https://sacoronavirus.co.za/" target="_blank">Stay updated on COVID-19 <span class="text-primary">here</span></a>
    </div>
     <div id="lte-banner">
      <router-link class="btn btn-sm  btn-dark btn-block lte" to="/fixed-lte/signup">Need internet? <span class="text-primary">not sure what's available in your area? </span>click here</router-link>
    </div>
    <div class="collapse justify-content-md-center" id="registration-dropdown">
      <p class="message" v-bind:class="{ error: has_error }" v-if="display_message">{{ message }}</p>
      <div
        class="card card-body contact-number col-md-4"
        v-if="!otp_sent"
      >
        <p>Please enter a valid me&amp;you mobile number to create an account.</p>
        <the-mask
          type="tel"
          mask=" ### ### #### "
          v-validate="'required|digits:10'"
          name="mobile_number"
          data-vv-as="Mobile Number"
          placeholder="Enter Your Mobile Number eg. 061 555 9988"
          class="form-control"
          v-model="mobile_no"
        />
        <transition name="slide">
          <span
            class="error-message"
            v-if="errors.has('mobile_number')"
          >A valid 10 digit SA mobile number is required (eg: 076 1234 567).</span>
        </transition>
        <button type="button" class="btn btn-block btn-sm" @click="sendOtp">
          Send OTP
          <i aria-hidden="true" class="fa fa-chevron-right"></i>
        </button>
      </div>
      <div class="card card-body form-group confirm-otp  col-md-4" v-if="otp_sent && !otp_confirmed">
        <p>A One Time Pin has been sent to your me&amp;you mobile number.</p>
        <the-mask
          type="tel"
          mask="###-###"
          v-validate="'required|digits:6'"
          name="otp"
          data-vv-as="OTP"
          placeholder="Enter Your OTP"
          class="form-control"
          v-model="otp"
        />
        <transition name="slide">
          <span class="error-message" v-if="errors.has('otp')">A 6 digit One time pin is required.</span>
        </transition>
        <button type="button" class="btn btn-outline-primary btn-block btn-sm" @click="confirmOtp">
          Confirm OTP
          <i aria-hidden="true" class="fa fa-chevron-right"></i>
        </button>
        <button type="button" class="btn btn-link text-primary btn-sm mt-1" @click="resendOtp">Request a new OTP</button>
      </div>
      <div
        class="card card-body form-group complete-account  col-md-4"
        v-if="otp_confirmed && otp_sent && !account_complete"
      >
        <p>Congratulations your account has been created. Please enter a valid email address and password to complete your account.</p>
        <p class="sub-text">These details will be used for you to login to your account</p>
        <div class="form-group">
          <input
            type="text"
            class="form-control"
            placeholder="Enter email"
            autocomplete="username"
            v-model="user_name"
            v-validate="'required|email'"
            name="email"
          />
          <transition name="slide">
            <span
              class="error-message"
              v-if="errors.has('email')"
            >A valid email address is required.</span>
          </transition>
        </div>

        <div class="form-group">
          <input
            type="password"
            class="form-control"
            name="password"
            placeholder="Password"
            v-validate="'required|min:6'"
            autocomplete="current-password"
            v-model="password"
          />
          <transition name="slide">
            <span
              class="error-message"
              v-if="errors.has('password')"
            >Password must be have atleast 6 characters.</span>
          </transition>
        </div>
        <button
          type="button"
          class="btn btn-outline-primary btn-block btn-sm"
          @click="completeAccount"
        >
          Complete Account
          <i aria-hidden="true" class="fa fa-chevron-right"></i>
        </button>
      </div>
      <div
        class="card card-body form-group confirm-otp col-md-4"
        v-if="otp_confirmed && otp_sent && account_complete"
      >
        <p>Account complete, please use your email address and passowrd to login above.</p>
      </div>
      <div class="cancel">
        <button
          class="btn text-secondary btn-link btn-sm btn-block"
          @click="cancelRegistraion"
          data-toggle="collapse"
          data-target="#registration-dropdown"
          aria-expanded="false"
          aria-controls="registration-dropdown"
        >cancel</button>
      </div>
    </div>
  </header>
</template>

<script>
import ContactService from "@/services/contact.service.js";
import CustomerService from "@/services/customer.service.js";

export default {
  name: "site-header",
  components: {},
  data: function() {
    return {
      form: {
        first_name: "",
        last_name: "",
        contact_number: ""
      },
      is_loading: false,
      error_message: "",
      has_error: false,
      display_message: false,
      message: "",
      otp_sent: false,
      otp_resent: false,
      otp_confirmed: false,
      mobile_no: "",
      otp: "",
      action: "account_create",
      user_name: "",
      password: "",
      account_complete: false
    };
  },
  methods: {
    callMeBack: function() {
      var self = this;
      self.is_loading = true;
      self.$validator.validateAll().then(success => {
        if (!success) return (self.is_loading = success);
        ContactService.callMeBack(self.form)
          .then(({ data }) => {
            self.$log.debug("callMeBack Response", data);
            if (data.success) {
              const elem = this.$refs.close;
              elem.click();
            } else {
              self.has_error = true;
              self.error_message =
                "Sorry, there is an error. Please use an alternative contact method.";
            }
            self.is_loading = false;
          })
          .catch(ex => {
            self.$log.error(ex);
            self.is_loading = false;
            self.has_error = true;
            self.error_message =
              "Sorry, there is an error. Please use an alternative contact method.";
          });
      });
    },
    sendOtp(is_resend = false) {
      var self = this;
      self.is_loading = true;
      self.message = "";
      CustomerService.sendOtp(self.mobile_no)
        .then(function({ data }) {
          var response = data;
          self.$log.debug("Send OTP response", response);
          if (response.success && response.data) {
            self.$log.debug("OTP Sent");
            self.otp_sent = true;
            if (is_resend) self.is_resend = true;
          }
          self.is_loading = false;
        })
        .catch(function({ response }) {
          self.$log.error("Error sending OTP", response);
          self.has_error = true;
          self.display_message = true;
          self.message = response.data.message;
          self.is_loading = false;
        });
    },
    cancelRegistraion() {
      var self = this;
      self.display_message = false;
      self.has_error = false;
      self.otp_sent = false;
      self.otp_resent = false;
      self.otp_confirmed = false;
      self.mobile_no = "";
      self.otp = "";
      self.is_loading = false;
      self.user_name = "";
      self.password = "";
    },
    resendOtp() {
      var self = this;
      self.display_message = false;
      self.sendOtp(true);
    },
    confirmOtp() {
      var self = this;
      self.is_loading = true;
      self.display_message = false;
      CustomerService.confirmOtp(self.mobile_no, self.otp, self.action)
        .then(function({ data }) {
          var response = data;
          self.$log.debug("Confirm OTP response", response);
          if (response.success) {
            self.$log.debug("OTP Confirmed");
            self.otp_confirmed = true;
            self.order_id = response.data.order_id;
          } else {
            self.display_message = true;
            self.message = response.message;
            self.has_error = true;
          }
          self.is_loading = false;
        })
        .catch(function({ response }) {
          self.$log.error("Error confirming OTP", response);
          self.has_error = true;
          self.display_message = true;
          self.message = response.data.message;
          self.is_loading = false;
        });
    },
    completeAccount() {
      var self = this;
      self.is_loading = true;
      self.display_message = false;

      self.$validator.validateAll().then(success => {
        if (!success) {
          self.is_loading = success
          return success;          
        }
        CustomerService.completeAccount(
          self.mobile_no,
          self.otp,
          self.order_id,
          self.user_name,
          self.password
        )
          .then(function({ data }) {
            var response = data;
            self.$log.debug("Confirm OTP response", response);
            if (response.success) {
              self.$log.debug("OTP Confirmed");
              self.account_complete = true;
            } else {
              self.display_message = true;
              self.message = response.message;
              self.has_error = true;
            }
            self.is_loading = false;
          })
          .catch(function({ response }) {
            self.$log.error("Error completing account", response);
            self.has_error = true;
            self.display_message = true;
            self.message = response.data.message;
            self.is_loading = false;
          });
      });
    }
  }
};
</script>

 
